import angular from 'angular'

angular.module('nominas.nomina')
  .service('NominasNominaMovimientosMovimiento', NominasNominaMovimientosMovimiento)

function NominasNominaMovimientosMovimiento($http) {
  this.put = _put
  this.delete = _delete

  function _put(id_proyecto, id_nomina, id_colaborador, data) {
    return $http.put('api/nominas/nomina/empleados/empleado', data, {
      params: {id_proyecto: id_proyecto, id_nomina: id_nomina, id_colaborador: id_colaborador},
      clearCache: 'nominas',
    })
  }

  function _delete(id_proyecto, id_nomina, id_colaborador) {
    return $http.delete('api/nominas/nomina/empleados/empleado', {
      params: {id_proyecto: id_proyecto, id_nomina: id_nomina, id_colaborador: id_colaborador},
      clearCache: 'nominas',
    })
  }

  /*function format(data, reverse) {
    return $schema(data, {
      Subtotal           : "number",
      Comision_Porcentaje: "number",
      Comision_Importe   : "number",
      Total              : "number",
      Saldo              : "number",
      Status             : "boolean"
    }, reverse);
  }*/
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/services/Nomina/Movimientos/Movimiento.js